import React, { Component } from 'react';
import PropTypes from 'prop-types'
import * as types from '../../../../constants/actionTypes';
import Drawer from '../../../Common/Drawer/Drawer';
import Notification from '../../../Common/Notification';
import MultiSelectBox from '../../../Common/MultiSelectBox/MultiSelectBox';
import DatePicker from '../../../Common/DatePicker/DatePicker';
import LoadingIndicator from '../../../Common/LoadingIndicator/LoadingIndicator';
import Toggle from '../../../Common/Toggle/Toggle';
import Moment from 'moment';
import { DATE_FORMAT } from '@Constants/constants';

export default class PushdownDrawer extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            selectedManagerId: "",
            selectedBaselineIds: "",
            zeroDate: "",
            isFormValid: true,
            sendEmail: true,
            isSaving: false,
            isShowingDOWPicker: false,
            project: {},
            projectEpicLabels: [],
            epicDates: [],
            daysSelected: [0, 1, 2, 3, 4, 5, 6] //Sun - Sat
        };
    }

    formIsValid = () => {
        if (this.state.selectedManagerId === "" || this.state.selectedBaselineIds === "" ||
            (this.state.zeroDate === "" || this.state.zeroDate === "Invalid date")) {
            return false;
        } else {
            return true;
        }
    }

    onSaveClick = () => {
        // update isSaving immediately to remove Push button to prevent multiple api calls from double-clicks
        if (this.state.isSaving === false) {
            this.setState({ isSaving: true }, this.save);
        }
    }

    save = async () => {
        if (this.formIsValid()) {
            try {

                const request = {
                    locationIds: this.props.selectedProjectLocations.map(m => m.locationId),
                    baselineIds: this.state.selectedBaselineIds.split(","),
                    projectKey: this.props.projectKey,
                    projectManagerId: this.state.selectedManagerId,
                    zeroDate: this.state.zeroDate,
                    sendEmail: this.state.sendEmail,
                    daysSelected: this.state.daysSelected,
                    epicDates: this.state.epicDates,
                    projectName: this.props.projectName
                }

                const response = await this.props.projectLocationActions.pushdown(request);
                if (response.type === types.PUSHDOWN_PROJECTLOCATION_SUCCESS) {

                    // show warning message oncomplete if some locations have not been pushed
                    Notification("info", "Info", "We are publishing your project. This may take several minutes. You can move on to your next tasks in the meantime and we will email you when the project has published to all teams.", true, "toast-top-right", null, 1000);
                    this.props.onComplete();

                } else if (response.type === types.PUSHDOWN_PROJECTLOCATION_FAILURE) {
                    Notification("error", "An Error Occurred", response.payload.message);
                    this.setState({ isSaving: false });
                }
            } catch (error) {
                Notification("error", "Error", error);
                this.setState({ isSaving: false });
            }
        } else {
            this.setState({ isFormValid: false, isSaving: false });
        }

    }

    onChangeManager = (id) => {
        this.setState({ selectedManagerId: id });
    }

    onChangeBaseline = (ids) => {
        this.setState({ selectedBaselineIds: ids });
    }

    onChangeZeroDate = (date) => {
        this.setState({ zeroDate: date });
    }

    onChangeEpicDate = (calendarDate, epicLabel) => {
        var date = Moment.utc(calendarDate);

        this.setState(prevState => {
            // Check if epicLabel already exists in the epicDates array
            const labelIndex = prevState.epicDates.findIndex(label => label.projectEpicLabelId === epicLabel);

            if (labelIndex !== -1) {
                // If epicLabel exists, update its value
                return {
                    epicDates: prevState.epicDates.map((label, index) => {
                        if (index === labelIndex) {
                            return { ...label, value: date };
                        }
                        return label;
                    })
                };
            } else {
                // If epicLabel doesn't exist, append a new object to the array
                return {
                    epicDates: [...prevState.epicDates, { projectEpicLabelId: epicLabel, value: date }]
                };
            }
        });
    }

    onToggleChange = () => {
        this.setState({ sendEmail: !this.state.sendEmail });
    }

    onToggleShowMore = () => {
        this.setState({ isShowingDOWPicker: !this.state.isShowingDOWPicker })
    }

    onDOWChange = (isChecked, value) => {
        let daysList = this.state.daysSelected;
        if (isChecked) {
            this.setState({
                daysSelected: [...this.state.daysSelected, value]
            })
        }
        else {
            const index = daysList.indexOf(value);
            if (index > -1) {
                daysList.splice(index, 1);
                this.setState({
                    daysSelected: daysList
                })
            }
        }

    }

    async search() {
        try {
            const result = await this.props.projectActions.getProject(this.props.projectKey);
            const payload = result.payload;
            if (result.type === types.GET_PROJECT_SUCCESS) {
                this.setState({ project: payload.project, projectEpicLabels: payload.projectEpicLabels });
            } else if (result.type === types.GET_PROJECT_FAILURE) {
                Notification("error", "An Error Occurred", payload.message)
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error);
        } finally {
            this.setState({ isFetching: false });
        }
    }

    async componentDidMount() {
        await this.search();
    }

    render() {
        return (
            <div>
                <Drawer isWide={false}
                    title='Pushdown'
                    onSaveClick={(this.state.isSaving) ? null : this.onSaveClick}
                    saveText="Push"
                    isSaveDisabled={this.state.isSaving}
                    onCancelClick={this.props.onCancel}
                >
                    <LoadingIndicator isLoading={this.props.isLoading || this.state.isSaving} >
                        <form noValidate className={this.state.isFormValid ? "" : "was-validated"} >
                            <MultiSelectBox
                                name="baselines"
                                label="Baselines to Push"
                                idField="id"
                                valueField="name"
                                options={this.props.baselines}
                                selectedValues={this.state.selectedBaselineIds.toString()}
                                onChange={this.onChangeBaseline}
                                isRequired={true}
                                errorMessage="Baseline is required"
                                isMulti={true}
                            />

                            <MultiSelectBox
                                name="projectManager"
                                label="Project Manager"
                                idField="id"
                                valueField="name"
                                options={this.props.projectManagers}
                                selectedValues={this.state.selectedManagerId.toString()}
                                onChange={this.onChangeManager}
                                isRequired={true}
                                errorMessage="Project Manager is required"
                                isMulti={false}
                            />

                            <DatePicker
                                showIcon
                                value={this.state.zeroDate}
                                name="zeroDate"
                                label={this.state.project.zeroDateName?.trim() ? this.state.project.zeroDateName : 'Zero Date'}
                                onChange={this.onChangeZeroDate}
                                isRequired={true}
                                errorMessage="Zero Date is required"
                                className="mb-3"
                            />

                            {
                                this.state.projectEpicLabels.map((epicLabel, index) => {
                                    const epicDateObj = this.state.epicDates.find(
                                        d => d.projectEpicLabelId === epicLabel.id
                                    );

                                    const value = epicDateObj?.value ? epicDateObj.value.format(DATE_FORMAT) : '';

                                    return (
                                        <DatePicker
                                            showIcon
                                            key={index}
                                            value={value}
                                            name={`${epicLabel.id}`}
                                            label={epicLabel.name}
                                            onChange={(date) => this.onChangeEpicDate(date, epicLabel.id)}
                                            className="mb-3"
                                        />
                                    );
                                })
                            }

                            <Toggle name="sendEmail" text="Send Pushdown Notification Email" checked={this.state.sendEmail} onChange={this.onToggleChange} />
                        </form>
                    </LoadingIndicator>
                </Drawer>
            </div>
        )
    }
}

PushdownDrawer.propTypes = {
    projectLocationActions: PropTypes.object.isRequired,
    projectActions: PropTypes.object.isRequired,
    projectManagers: PropTypes.array.isRequired,
    baselines: PropTypes.array.isRequired,
    selectedProjectLocations: PropTypes.array.isRequired,
    subscriptionId: PropTypes.string.isRequired,
    projectKey: PropTypes.string.isRequired,
    projectName: PropTypes.string.isRequired,
    onComplete: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired
};
